/* filepath: /Users/george/MatrizInc/MarketBrewer/Clients/street-lawyer-services/website/src/core/components/Header/Logo.tsx */
import React from "react";
import { Link } from "react-router-dom";

const Logo = () => {
  return (
    <Link
      to="/"
      className="flex items-center transition-transform duration-200 hover:scale-105"
      aria-label="Street Lawyer Services Home"
    >
      <img
        src="/images/logo/street-lawyer-services-logo.png"
        alt="Street Lawyer Services Logo"
        className="h-10 md:h-12"
        loading="eager"
        fetchpriority="high"
        onError={(e) => {
          e.currentTarget.style.display = "none";
          e.currentTarget.insertAdjacentHTML(
            "afterend",
            '<span class="text-white font-bold text-xl">Street Lawyer Services</span>'
          );
        }}
      />
    </Link>
  );
};

export default React.memo(Logo);
